import FilterCoverDemo from '@/assets/images/styleFilterMarket/FilterCoverDemo.webp';
import { TrackList } from '@/components/TrackList';
import { Button } from '@/components/ui/button';
import { getStyleFilterGroupList } from '@/service/filter';
import { useTrackLists } from '@/state/style-filter-list-store';
import { useRequest } from 'ahooks';
import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArtistLink } from './components/ArtistLink';
import FilterCards from './components/FilterCards';
import LearnMoreCard from './components/LearnMoreCard';
import MarketHeader from './components/MarketHeader';

const StyleFilterMarketDesktop: React.FC = () => {
  const { marketAudioListData } = useTrackLists();
  const trackListRef = useRef<HTMLDivElement>(null);

  const { data: getStyleFilterGroupData } = useRequest(getStyleFilterGroupList);

  const sfDetail = getStyleFilterGroupData?.data?.[0];
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F6F6F7]">
      <div className="max-w-[1440px] mx-auto px-12 pt-12 pb-6">
        <MarketHeader trackListRef={trackListRef} />
      </div>
      <div className="pl-12 pb-6">
        <FilterCards getStyleFilterGroupData={getStyleFilterGroupData} />
      </div>
      <div className="max-w-[1440px] mx-auto px-12 pb-16">
        <LearnMoreCard />
      </div>
      <div className="max-w-[1440px] mx-auto px-12 my-6 flex justify-center items-center">
        <div className="relative">
          <div className="flex items-center absolute top-8 left-8 z-10">
            <ArtistLink artist={sfDetail} textClassName="text-white" avatarClassName="border-white" />
          </div>
          <img src={FilterCoverDemo} alt="Filter Cover Demo" className="w-full h-auto rounded-xl" />
          <Button
            variant="outline"
            type="button"
            className="absolute bg-transparent text-white bottom-4 right-4 z-10 text-[14px]"
            onClick={() => {
              navigate(`/marketplace/artist/imogen-heap`);
            }}
          >
            Learn more
          </Button>
        </div>
      </div>
      <div className="max-w-[1440px] mx-auto px-12 mt-6 pb-6" ref={trackListRef}>
        <section className="p-8 bg-white rounded-xl border border-[#D4D4DA]">
          <h2 className="text-[32px] text-[#111112] tracking-[-0.96px] leading-10 mb-6">
            Tracks Jenerated with
            <div>
              <span>Imogen Heap </span>StyleFilters™
            </div>
          </h2>
          <TrackList trackListData={marketAudioListData['IMO-ALL']} label={{ title: 'Title', creator: 'User', filter: 'StyleFilter' }} />
        </section>
      </div>
    </div>
  );
};

export default StyleFilterMarketDesktop;
